'use strict';

const sanitizeHtml = (value) => {
  // Prefer DOMPurify if available; otherwise, render nothing for safety
  if (typeof DOMPurify !== 'undefined' && DOMPurify && typeof DOMPurify.sanitize === 'function') {
    try {
      return DOMPurify.sanitize(value, {
        ALLOWED_TAGS: ['a', 'b', 'br', 'code', 'h4', 'p', 'strong', 'em'],
        ALLOWED_ATTR: ['href', 'target'],
      });
    } catch (e) {
      // If sanitization fails, fall back to empty string
      console.error('DOMPurify sanitize failed', e);
      return '';
    }
  } else {
    // If DOMPurify is not available, render nothing
    console.error('DOMPurify not present');
    return '';
  }
};

angular.module('MoreI18n', ['pascalprecht.translate', 'ngCookies']);

angular.module('MoreI18n').factory('simpleInterpolation', function ($interpolate, $translateSanitization) {
  let $locale;

  return {
    setLocale: function (locale) {
      $locale = locale;
    },
    getInterpolationIdentifier: function () {
      return 'custom';
    },
    interpolate: function (value, parameters, context, sanitizeStrategy) {
      const sanitizedValue = $translateSanitization.sanitize(value, 'text', sanitizeStrategy);
      // Only interpolate if there are supplied parameters
      if (parameters) {
        const sanitizedParameters = $translateSanitization.sanitize(parameters, 'params', sanitizeStrategy);

        return sanitizeHtml(sanitizedValue.replace(/\{\{\s*(\w+)\s*\}\}/g, (_, key) => {
          return key in sanitizedParameters ? sanitizedParameters[key] : '';
        }));
      } else {
        return sanitizeHtml(value);
      }
    }
  };
});

angular.module('MoreI18n').config(['$translateProvider', function ($translateProvider) {

  // Copied from angular-translate 2.5.1
  // tries to determine the browsers language
  var getFirstBrowserLanguage = function () {
    var nav = window.navigator,
        browserLanguagePropertyKeys = ['language', 'browserLanguage', 'systemLanguage', 'userLanguage'],
        i,
        language;

    // support for HTML 5.1 "navigator.languages"
    if (angular.isArray(nav.languages)) {
      for (i = 0; i < nav.languages.length; i++) {
        language = nav.languages[i];
        if (language && language.length) {
          return language;
        }
      }
    }

    // support for other well known properties in browsers
    for (i = 0; i < browserLanguagePropertyKeys.length; i++) {
      language = nav[browserLanguagePropertyKeys[i]];
      if (language && language.length) {
        return language;
      }
    }

    return null;
  };

  // Copied from angular-translate 2.5.1
  // tries to determine the browsers locale
  var getLocale = function () {
    return (getFirstBrowserLanguage() || '').split('-').join('_');
  };

  var preferredLanguage = getLocale();
  if (preferredLanguage) {
    preferredLanguage = preferredLanguage.split('_')[0];
  } else {
    preferredLanguage = 'en';
  }

  $translateProvider
    .useSanitizeValueStrategy('sanitize')
    .useInterpolation('simpleInterpolation')
    .useMissingTranslationHandler('sanitizingMissingTranslationHandler')
    .translations('source', require('./translations/translation.json'))
    .translations('en', require('./translations/en/translation.json'))
    .translations('es', require('./translations/es/translation.json'))
    .translations('pt', require('./translations/pt/translation.json'))
    .translations('fr', require('./translations/fr/translation.json'))
    .translations('nl', require('./translations/nl/translation.json'))
    .translations('de', require('./translations/de/translation.json'))
    .translations('ca', require('./translations/ca/translation.json'))
    .useCookieStorage()
    .fallbackLanguage('source')
    .preferredLanguage(preferredLanguage);
}]);

angular.module('MoreI18n').factory('sanitizingMissingTranslationHandler', function () {
  return function (translationKey) {
    return sanitizeHtml(translationKey);
  };
});
